import Cookies from 'cookies-js';
import requestApi from '../requests/request_api';

export function getUserCookie(){
    return Cookies.get('user_token');
}

export function setUserCookies(user_token) {
    Cookies.set('user_token', user_token);
}